import { useCallback } from 'react';

import { CreateUserBankDetailsInput } from '__generated__/GQL';

import { useBankDetails } from '../useBankDetails';
import { useCreateBankDetailsMutation } from '../useCreateBankDetailsMutation';
import { useUpdateBankDetailsMutation } from '../useUpdateBankDetailsMutation';

export const useBankDetailsEdition = () => {
  const { data, loading } = useBankDetails();

  const [create, createHooks] = useCreateBankDetailsMutation();
  const [update, updateHooks] = useUpdateBankDetailsMutation();

  const saveBankDetails = useCallback(
    ({ iban, recipientName, swiftBic }: CreateUserBankDetailsInput) => {
      if (data?.viewer.profile.bankDetails?.bankDetailsId) {
        return update({
          bankDetailsId: data.viewer.profile.bankDetails.bankDetailsId,
          iban,
          recipientName,
          swiftBic,
        });
      }
      return create({
        iban,
        recipientName,
        swiftBic,
      });
    },
    [create, update, data?.viewer.profile.bankDetails?.bankDetailsId],
  );

  return {
    data: data ? data.viewer.profile.bankDetails : null,
    loading,
    saveBankDetails,
    saving: createHooks.loading || updateHooks.loading,
  };
};
